import 'performance-polyfill';

const getPerformance = () => window.performance.now();
export default getPerformance;



// WEBPACK FOOTER //
// ./client/app/scripts/principles/animations/performance.js